// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j-E6","top":"styles_top__3D5Fd","left":"styles_left__1ByrQ","description":"styles_description__3ELa2"};